import {
  ADD_VALUE,
  UPDATE_VALUE,
  REMOVE_VALUE,
} from './constants'

export const updateValue = (index, inputType, value) => {
  return {
    type: UPDATE_VALUE,
    value,
    index, 
    inputType
  }
}

export const addValue = () => {
  return {
    type: ADD_VALUE
  }
}

export const removeValue = (index) => {
  return {
    type: REMOVE_VALUE,
    index
  }
}
